import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@mui/material';

import InsightList from './InsightList';
import ClasswiseLearnerAttempatedAssignments from "./ClasswiseLearnerAttempatedAssignments";
import ClasswiseLearnerNotAttempatedAssignments from "./ClasswiseLearnerNotAttempatedAssignments";
import ClasswiseTopLearners from "./ClasswiseTopLearners";

import TopButton from '../../Components/UI/TopButtons';
import { currentMonth, getFormatedDate } from "../../Js/TimeAndDate";
import { getClassNames } from "../../Js/Common";
import { getClassWiseInsights } from "./Services";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";

const Insight = (props) => {
    // Redux state    
    const styles = useStyles();
    const navigation = useNavigate();
    const dispatch = useDispatch();    
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    const [allClasses, setAllClasses] = useState([]);
    const [selectedClass, setSelectedClass] = useState(null);
    const [classWiseLearnersData, setClassWiseLearnersData] = useState(null);
    const [questionType, setQuestionType] = useState(null);

    const [startOfDate, setStartOfDate] = useState(null);
    const [endOfMonth, setEndOfMonth] = useState(null);

    useEffect(() => {
        let objCurrentMonth = currentMonth('YYYY-MM-DD');
        setStartOfDate(objCurrentMonth.startOfMonth);
        setEndOfMonth(objCurrentMonth.endOfMonth);

        const initialRender = async () => {
            let classesData = await getClassNames(userInfo.site_uuid);
            if (classesData.length === 0) {
                return;
            }
            setAllClasses(classesData);
            return;
        }

        dispatch(commonSliceActions.resetState());
        initialRender();
    }, []);

    useEffect(() => {
        setQuestionType(null);
        setClassWiseLearnersData(null);
    }, [selectedClass]);

    const handleQuestionAns = async (qType) => {
        setQuestionType(qType);
        await fetchClassWiseInsights(qType);
    };

    const handleParamsNavigate = (learnerData) => {
        console.log("learnerData=====>",learnerData);
        dispatch(
            commonSliceActions.setParamsData({
                learnerData: learnerData   
            })
        );
        navigation(`/Report/InsightAssignmentList`);
    };

    const fetchClassWiseInsights = async (qType) => {
        let created_by = []
        if (userInfo.rolesInfo.title.toLowerCase() == 'trainer') {
            created_by.push(userInfo.uid);
        }
        let params = {
            query: {
                'belongs_to': selectedClass,
                'site_uuid': userInfo.site_uuid,
                'questionType': qType
            },

        };
        if (created_by.length > 0) {
            params.query.created_by = created_by;
        }
        let resClassWiseLearners = await getClassWiseInsights(params);
        console.log("resClassWiseLearners======>",resClassWiseLearners);

        if (qType == 'least_attempted_assignments') {
            resClassWiseLearners.data.map((learnerData) => {
                learnerData.total_not_attempted_assignment = (+learnerData.total_assignments - +learnerData.total_attempted_assignment);
            });
            resClassWiseLearners.data.sort((a, b) => b.total_not_attempted_assignment - a.total_not_attempted_assignment);
        } else if (qType == 'most_attempted_assignments') {
            resClassWiseLearners.data.map((learnerData) => {
                console.log("total_attempted_assignment", +learnerData.total_attempted_assignment);

                learnerData.total_not_attempted_assignment = (+learnerData.total_assignments - +learnerData.total_attempted_assignment);
            });
            resClassWiseLearners.data.sort((a, b) => b.total_attempted_assignment - a.total_attempted_assignment);
        } else if (qType == 'learner_top_of_class') {
            resClassWiseLearners = resClassWiseLearners;
        }
        setClassWiseLearnersData(resClassWiseLearners)
    }

    return (
        <>
            <TopButton
                title={"Insights for a clear view!"}
                // secondaryText={getFormatedDate(startOfDate, 'MMM DD,YYYY') + ' - ' + getFormatedDate(endOfMonth, 'MMM DD,YYYY')}
                dropDownData={allClasses}
                fetchBySelectedValue={(classId) => { setSelectedClass(classId) }}
                isLearnerFilter={false}
                //handleFilterReport={handleFilterClassReport}
            />
            <Grid container>
                <Grid item xs={12}>
                    <Grid container sx={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around', px: 1 }}>
                        <Grid item
                            xs={5}
                            sx={{ py: 1, pr: 5, pl: 2, height: '75vh', overflow: 'auto'}}
                            className={styles.scrollBar}
                        >
                            <InsightList 
                                handleQuestionAns={handleQuestionAns} 
                                selectedClassId={selectedClass}
                            />
                        </Grid>
                        <Grid item xs={7} sx={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around', py: 1, pr: 5, pl: 2}}>
                            {questionType == 'least_attempted_assignments' &&
                                <ClasswiseLearnerNotAttempatedAssignments
                                    classWiseLearnersData={classWiseLearnersData}
                                    handleNavigate={handleParamsNavigate}
                                />
                            }
                            {questionType == 'most_attempted_assignments' &&
                                <ClasswiseLearnerAttempatedAssignments
                                    classWiseLearnersData={classWiseLearnersData}
                                    handleNavigate={handleParamsNavigate}
                                />
                            }
                            {questionType == 'learner_top_of_class' &&
                                <ClasswiseTopLearners
                                    classWiseLearnersData={classWiseLearnersData}
                                    handleNavigate={handleParamsNavigate}
                                />
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
})
export default Insight;